import styled from 'styled-components';
import { InputLabel, TextField } from '@material-ui/core';

export const BSLabel = styled(InputLabel)`
  &&.MuiFormLabel-root {
    position: absolute;
    top: -8px;
    left: 0;
    font-size: 13px;
    font-weight: 500;
    transform: none;
  }
`;

export const TextFieldWrapper = styled(TextField)`
  &&.small {
    .MuiInputBase-root {
      padding: 0;
    }
    input {
      padding: 10.5px 14px !important;
    }
  }
`;
